import $ from 'jquery';
import constants from 'Constants.js';
import Immutable from 'immutable';
import util from 'util/Util.js';
import BasePropertyView from 'BasePropertyView.js';
import formatTemplate from 'properties/main/show-success.ejs';

class MainShowSuccess extends BasePropertyView {

    initialize( opts ) {
        this.options = opts || {};
        this.template = formatTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change textarea[name="confirmationMessage"]' : 'updateAttributes',
            'change input[name="showConfirmation"]' :'updateShowSuccess',
            'blur textarea'   : 'lostFocus',
            'focus textarea'   : 'getFocus'
        };

        // Add needed property
        if (this.model.get('showConfirmation') === undefined) {
            this.model.set('showConfirmation',false, {silent: true});
        }

        // Add needed property
        if (!this.model.get('confirmationMessage')) {
            this.model.set('confirmationMessage', '', {silent: true});
        }

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = util.sanitizeHTML(ev.currentTarget.value, true, this.model.get(propName));

        this.model.set( propName, propVal );
    }

    updateShowSuccess(ev){
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.checked;
        this.model.set( propName, propVal );
    }

    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        this.delegateEvents();
        $(`input[name='showConfirmation']`).attr('checked',util.isTrue(this.model.get('showConfirmation')) );
        $(`textarea[name='confirmationMessage']`).val(this.model.get('confirmationMessage'));
        return this;
    }

}

export default MainShowSuccess;
